import { render, staticRenderFns } from "./CategoryProducts.vue?vue&type=template&id=9e46667c"
import script from "./CategoryProducts.vue?vue&type=script&lang=js"
export * from "./CategoryProducts.vue?vue&type=script&lang=js"
import style0 from "./CategoryProducts.vue?vue&type=style&index=0&id=9e46667c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports